import { Mail } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/ui/elements/button/Button';

type ForgotPasswordProps = {
  setStep: (step: string) => void;
};

function ForgotPassword({ setStep }: ForgotPasswordProps) {
  const [email, setEmail] = useState('');
  const isValidEmail = (email: string): boolean =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const { t } = useTranslation('login');

  return (
    <>
      <div className="flex flex-col gap-2 text-center sm:text-left">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-mail-icon rounded-full flex items-center justify-center">
            <Mail className="w-8 h-8 text-surface" aria-hidden="true" />
          </div>
        </div>
        <h2 className="font-semibold text-center text-2xl text-lt-slate-900">
          {t('forgotPasswordTitle')}
        </h2>
        <p className="text-sm text-center text-lt-slate-500">
          {t('forgotPasswordDescription')}
        </p>
      </div>

      <form className="space-y-5 py-4">
        <div className="space-y-2">
          <label
            className="flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50 text-lt-slate-700"
            htmlFor="reset-email"
          >
            {t('emailAddressLabel')}
          </label>
          <input
            type="email"
            className="placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 
                             flex w-full min-w-0 border px-3 py-1 text-base bg-input-background transition-[color,box-shadow] outline-none 
                             disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring 
                             focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 
                             dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-12 border-slate-300 rounded-lg"
            id="reset-email"
            placeholder="admin@company.com"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="flex gap-3">
          <Button
            data-slot="button"
            variant="outlineGray"
            size="flex"
            type="button"
            className="has-[&>svg]:px-3"
          >
            {t('cancel')}
          </Button>

          <Button
            data-slot="button"
            variant="primaryBlue"
            size="flex"
            type="submit"
            className="has-[&>svg]:px-3"
            disabled={!isValidEmail(email)}
            onClick={() => setStep('otp')}
          >
            {t('sendResetLinkButton')}
          </Button>
        </div>

        <p className="text-xs text-center text-slate-500 pt-2">
          {t('resetLinkInfo')}
        </p>
      </form>
      {/*  */}

      {/*  */}
    </>
  );
}

export default ForgotPassword;
